module.exports = __webpack_public_path__ + "img/news1-7.76b27cf9.png";